package nl.volleyplanner.web.base.component

import kotlinx.html.*
import nl.volleyplanner.web.base.HTMLComponent
import nl.volleyplanner.web.base.component

data class TabPaneElement(
    val tabTitle: String,
    val tabHtmlId: String,
    val contentHtmlId: String,
    val component: HTMLComponent
)

fun FlowContent.tabPane(tabPaneHtmlId: String, tabPaneElements: List<TabPaneElement>) {
    div {
        ul(classes = "nav nav-tabs") {
            id = tabPaneHtmlId
            role = "tablist"

            tabPaneElements.forEachIndexed { index, tabPaneElement ->
                li(classes = "nav-item") {
                    role = "presentation"

                    button(classes = "nav-link") {
                        if (index == 0) classes += "active"
                        id = tabPaneElement.tabHtmlId
                        attributes["data-bs-toggle"] = "tab"
                        attributes["data-bs-target"] = "#${tabPaneElement.contentHtmlId}"
                        type = ButtonType.button
                        role = "tab"
                        attributes["aria-controls"] = tabPaneElement.contentHtmlId
                        attributes["aria-selected"] = (index == 0).toString()
                        +tabPaneElement.tabTitle
                    }
                }
            }
        }
        div(classes = "tab-content mt-2") {
            id = "${tabPaneHtmlId}-content"

            tabPaneElements.forEach { tabPaneElement ->
                div(classes = "tab-pane fade show active") {
                    id = tabPaneElement.contentHtmlId
                    role = "tabpanel"
                    attributes["aria-labelledby"] = tabPaneElement.tabHtmlId

                    component(tabPaneElement.component)
                }
            }
        }
    }
}